// shared styles
import '../../scss/shared/shared.scss';

// ieToEdge
import './static/ieToEdge';
